<div
    class="dual-doughnut position-relative"
    [class.enable-animation]="enableAnimation()"
    [class.disable-animation]="!enableAnimation()"
    [attr.title]="label1() && label2() ? label1() + ' / ' + label2() : (label1() ?? label2())"
    [style.width]="chartConfig.container"
    [style.height]="chartConfig.container"
>
    <svg class="dual-doughnut--container">
        <circle
            class="dual-doughnut--circle"
            [attr.cx]="chartConfig.cx"
            [attr.cy]="chartConfig.cy"
            [attr.r]="chartConfig.outerR"
            [style.stroke]="circleColor()"
        />
        <circle
            class="dual-doughnut--progress"
            [attr.cx]="chartConfig.cx"
            [attr.cy]="chartConfig.cy"
            [attr.r]="chartConfig.outerR"
            [style.stroke]="color1"
            [style.stroke-dasharray]="outerCurve"
            [style.stroke-linecap]="'round'"
        />
        <circle
            class="dual-doughnut--circle"
            [attr.cx]="chartConfig.cx"
            [attr.cy]="chartConfig.cy"
            [attr.r]="chartConfig.innerR"
            [style.stroke]="circleColor()"
        />
        <circle
            class="dual-doughnut--progress"
            [attr.cx]="chartConfig.cx"
            [attr.cy]="chartConfig.cy"
            [attr.r]="chartConfig.innerR"
            [style.stroke]="color2"
            [style.stroke-dasharray]="innerCurve"
            [style.stroke-linecap]="'round'"
        />
    </svg>

    <div
        class="dual-doughnut--label d-flex flex-column justify-content-center align-items-center"
        [dir]="_languageService.direction()"
        [style.width]="chartConfig.container"
        [style.top]="chartConfig.label.position"
    >
        @if (chartConfig.label.labelFontSize && label1()) {
            <span class="label fw-bold d-block" [style.font-size]="chartConfig.label.labelFontSize">
                {{ label1() }}
            </span>
        }
        <span class="number d-block fw-bold" [style.font-size]="chartConfig.label.amountFontSize" [style.color]="color1">
            @if (amount1() > 0) {
                <adaa-count-up [total]="amount1()" [symbol]="symbol()" [fontSize]="chartConfig.label.amountFontSize" />
            } @else {
                @if (symbol() === "C") {
                    {{ amount1() | currencyValue: true }}
                } @else if (symbol() === "%") {
                    {{ amount1() | percentageValue }}
                } @else {
                    {{ amount1() }}
                }
            }
        </span>

        @if (chartConfig.label.labelFontSize && label2()) {
            <span class="label fw-bold d-block" [style.font-size]="chartConfig.label.labelFontSize">
                {{ label2() }}
            </span>
        }
        <span class="number d-block fw-bold" [style.font-size]="chartConfig.label.amountFontSize" [style.color]="color2">
            @if (amount2() > 0) {
                <adaa-count-up [total]="amount2()" [symbol]="symbol()" [fontSize]="chartConfig.label.amountFontSize" />
            } @else {
                @if (symbol() === "C") {
                    {{ amount2() | currencyValue: true }}
                } @else if (symbol() === "%") {
                    {{ amount2() | percentageValue }}
                } @else {
                    {{ amount2() }}
                }
            }
        </span>
    </div>
</div>
